module.exports = __webpack_public_path__ + "img/yes.4a8f4957.svg";